const text = {
    primary: "#151F28",
};

export default text;
